import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function DashboardLayout({ title, subtitle, navItems, sidebarStorefront, children, headerExtra }) {
  const { profile, logout } = useAuth();
  const displayName =
    profile?.name ||
    [profile?.given_name, profile?.family_name].filter(Boolean).join(' ') ||
    profile?.preferred_username ||
    'User';

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <h1>SalesBotics</h1>
          {sidebarStorefront || <span>{title}</span>}
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-chip">
            <strong>{displayName}</strong>
            <span>{profile?.email || profile?.preferred_username}</span>
          </div>
          <button type="button" className="btn btn-secondary" style={{ width: '100%' }} onClick={logout}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="main-content">
        {subtitle && (
          <div className="page-header">
            <div>
              <h2>{subtitle}</h2>
            </div>
            {headerExtra}
          </div>
        )}
        {children}
      </main>
    </div>
  );
}

export function PageHeader({ title, description, actions }) {
  return (
    <div className="page-header">
      <div>
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}

export function Modal({ title, open, onClose, children, footer }) {
  if (!open) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div className="modal" onClick={(event) => event.stopPropagation()} role="dialog">
        <div className="modal-header">
          <h3>{title}</h3>
          <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export function ErrorBanner({ message }) {
  if (!message) {
    return null;
  }
  return <div className="error-banner">{message}</div>;
}

export function LoadingState() {
  return (
    <div className="empty-state">
      <div className="spinner" style={{ margin: '0 auto 1rem' }} />
      <p>Loading…</p>
    </div>
  );
}

export function EmptyState({ message }) {
  return <div className="empty-state">{message}</div>;
}
